import StarRoundedIcon from "@mui/icons-material/StarRounded"
import { Grid, LinearProgress, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import parse from "html-react-parser"
import ConfettiExplosion from "react-confetti-explosion"
import { useTranslation } from "react-i18next"
import { useDialogData } from "../../dialogs/context/DialogProvider"
import { useGamesData } from "../context/GamesProvider"

export const GameHeader = () => {
  const { currentId } = useDialogData()
  const { current, progress, isValid } = useGamesData()
  const { t } = useTranslation()
  const { palette } = useTheme()
  // const [hasImage, setHasImage] = useState(true)

  // useEffect(() => {
  //   setHasImage(true)
  // }, [current])

  return (
    <Grid
      item
      container
      width={"100%"}
      mt={6}
    >

      {/* title */}
      <Grid item xs={12}>
        <Typography variant="h2" color="primary">
          {parse(t(`ui.info.${currentId}`))}
        </Typography>
      </Grid>

      {/* rules */}
      <Grid item xs={12}>
        <Grid
          container
          width={"100%"}
          spacing={3}
          mb={5}
          sx={{ mt: "1em", mb: "1em" }}
        >
          {/* <Grid item xs={4} display={hasImage ? "block" : "none"}>
            <Box
              component={"img"}
              src={`./img/games/${current?.id}.png`}
              alt=""
              sx={{ width: "100%", marginLeft: "2em" }}
              onError={(e) => {
                e.currentTarget.src = ""
                // if (Object.keys(current || {}).length !== 0) {
                //   setHasImage(false)
                // }
              }}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Typography variant="h3" color="grey">
              {parse(t(`games.${current?.id}.instruction`))}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* progress bar */}
      <Grid item xs={12} container alignItems="center" justifyContent="center">
        <Grid item xs={7}>
          <LinearProgress
            value={progress * 100}
            variant="determinate"
            color="secondary"
          />
        </Grid>
        <Grid item container justifyContent="center" xs={1}>
          {isValid && (
            <ConfettiExplosion
              force={1}
              duration={5000}
              width={1500}
              colors={[
                palette.primary.main,
                palette.secondary.main,
                palette.error.main,
                palette.success.main,
              ]}
            />
          )}
          <StarRoundedIcon
            sx={{
              fontSize: 50,
              color: isValid ? "secondary.main" : "grey.500",
              animation: isValid ? "bounce 1s ease infinite" : "",
              "@keyframes bounce": {
                "0%": {
                  transform: "scale(1) rotate(0deg)",
                },
                "50%": {
                  transform: "scale(1.5) rotate(12deg)",
                },
                "100%": {
                  transform: "scale(1) rotate(0deg)",
                },
              },
            }}
          />
        </Grid>
      </Grid>

    </Grid>
  )
}
